// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { FC, ReactElement, useEffect } from 'react';

import AthomeHeader from '../AthomeHeader';
import BackToTop from '../BackToTop';
import Head from 'next/head';
import AthomeFooter from '../AthomeFooter';
import { StyledMain } from './Styled';

export const AthomeLayout: FC<{ page: ReactElement }> = ({ page }) => {
  useEffect(() => {
    document.documentElement.classList.add(
      'white-bg',
      'full-height',
      'additional-font'
    );

    return () => {
      document.documentElement.classList.remove(
        'white-bg',
        'full-height',
        'additional-font'
      );
    };
  }, []);

  return (
    <>
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function(d) {
                var config = {
                  kitId: 'mqg8ell',
                  scriptTimeout: 3000,
                  async: true
                },
                h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
              })(document);
            `
          }}
        />
      </Head>
      <AthomeHeader />
      <StyledMain>{page}</StyledMain>
      <AthomeFooter />
      <BackToTop />
    </>
  );
};

AthomeLayout.displayName = 'AthomeLayout';

export default AthomeLayout;
